import { Drawer } from '@mui/material'
import React from 'react'
import { useAppData } from '../../context/AppDataContext'
import CustomerForm from '../../app/admin/erp/customer/components/CustomerForm';

function ToolbarNav() {
  const {toolbarStatus,setToolbarStatus} = useAppData();

  const {getCustomerList,getCustomerDD} = useAppData();

  return (
    <Drawer 
      open={toolbarStatus} 
      onClose={()=>setToolbarStatus(!toolbarStatus)}  
      anchor='right'
      
    >
        <ul class="list-group">
          <li class="list-group-item">First item</li>
          <li class="list-group-item">Second item</li>
          <li class="list-group-item">Third item</li>
          <li class="list-group-item">
            <CustomerForm callBack={()=>{
              getCustomerList();
              getCustomerDD();
            }} 

          /> </li>

        </ul>
    </Drawer>
  )
}

export default ToolbarNav